import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader, getCurrentYear } from "../Helpers";
import logo from "../assets/logo.png";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const navLinks = [
  { key: "home", label: "Home" },
  { key: "about_us", label: "About Us" },
  { key: "services", label: "Services" },
  { key: "contact_us", label: "Contact" },
];

export default function Footer() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <footer className="fr-footer mt-5">
      <div className="container">
        <div className="fr-footer-cta">
          <div>
            <h5 className="font-bold mb-0 text-light">Clean, Affordable Energy for Everyone</h5>
            <p className="mb-0 small text-light">Partner with DOUBLE F for reliable renewable solutions.</p>
          </div>
          <a href="mailto:info@doublefsmartenergies.com" className="btn btn-warning text-dark p-2 btn-sm fr-btn-pop">
            Contact Partnership Desk
          </a>
        </div>

        <div className="fr-footer-grid">
          <div className="fr-footer-col">
            <img src={logo} alt="DOUBLE F SMART ENERGIES ENTERPRISE logo" className="fr-footer-logo mb-3" />
            <p className="fr-footer-text mb-3">
              DOUBLE F SMART ENERGIES ENTERPRISE is a renewable energy solutions company focused on delivering
              practical and affordable clean power systems across Africa.
            </p>
          </div>

          <div className="fr-footer-col">
            <h6 className="font-bold text-light mb-3">Navigate</h6>
            {navLinks.map((item) => (
              <button
                key={item.key}
                className="fr-footer-link"
                onClick={() => appContext.navTo({ item: item.key })}
              >
                {item.label}
              </button>
            ))}
          </div>

          <div className="fr-footer-col">
            <h6 className="font-bold text-light mb-3">Reach Out</h6>
            <div className="fr-footer-contact-item">
              <FaWhatsapp  className="flex-shrink-0"/>
              <a href="https://wa.me/255753311157" className="text-decoration-none text-light">
                 0753311157
              </a>
            </div>
            <div className="fr-footer-contact-item">
              <FaPhoneAlt  className="flex-shrink-0"/>
              <a href="tel:+255718034160" className="text-decoration-none text-light">
                 0718034160
              </a>
            </div>
            <div className="fr-footer-contact-item">
              <FaEnvelope />
              <a href="mailto:info@doublefsmartenergies.com" className="text-decoration-none text-light">info@doublefsmartenergies.com</a>
            </div>
            <div className="fr-footer-contact-item align-items-start">
              <FaMapMarkerAlt className="mt-1" />
              <span>Kijitonyama near Mabatini Police Station</span>
            </div>
          </div>
        </div>

        <div className="fr-footer-bottom">
          <p className="mb-0 fr-footer-mini">
            &copy; {getCurrentYear()} DOUBLE F SMART ENERGIES ENTERPRISE. All rights reserved.
          </p>
          <p className="mb-0 fr-footer-mini">Website Built By <a className="btn" href="https://werenium.com" target="_blank">Werenium Technologies</a></p>
        </div>
      </div>
    </footer>
  );
}
